import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BubbleUITextArea from '@bubble-contrib/molecule-text-area';

/** Wraps bubble UI contrib `TextArea` component to add `isBorderless` property. */
export const TextArea = ({ isBorderless = true, ...props }) => {
  useEffect(() => {
    if (isBorderless) {
      const textArea = document.getElementById(props.name);

      if (textArea) {
        textArea.style.padding = 0;

        if (textArea.parentElement?.parentElement) {
          textArea.parentElement.parentElement.style.padding = 0;
        }
      }
    }
  }, []);
  return <BubbleUITextArea {...props} isUnderlined={isBorderless} />;
};

TextArea.propTypes = {
  ...BubbleUITextArea.propTypes,
  isBorderless: PropTypes.bool,
  isUnderlined: PropTypes.bool,
};
